
  import { defineComponent, ref, computed, onMounted, reactive } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'offices-advanced-search',
    props: {
      summary: {
        type: Object,
        default: () => ({
          brokersCount: 0,
          marketeersCount: 0,
          totalCount: 0,
          filteredCount: 0,
        }),
      },
    },
    emits: ['type-selected', 'reset'],
    setup(props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref({
        email: '',
        phone: '',
        memberType: 'all',
        behaviorFilter: '',
        monthsWithoutRenewal: '1',
        daysWithoutAds: '14',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);
      const onBehaviorFilterChange = () => {
        const behaviors = selectedItems.value.behaviorFilter;

        if (behaviors.includes('expired_no_renewal')) {
          selectedItems.value.monthsWithoutRenewal ||= '1';
        } else {
          selectedItems.value.monthsWithoutRenewal = '1';
        }

        if (behaviors.includes('active_no_ads_usage')) {
          selectedItems.value.daysWithoutAds ||= '14';
        } else {
          selectedItems.value.daysWithoutAds = '14';
        }
      };

      const buildFilterPayload = () => {
        const behaviorFilter = selectedItems.value.behaviorFilter;
        const payload: Record<string, unknown> = {
          phone: selectedItems.value.phone,
          email: selectedItems.value.email,
          memberType: selectedItems.value.memberType,
        };
        if (!behaviorFilter || behaviorFilter === 'all') {
          payload.behaviorFilter = '';
          payload.monthsWithoutRenewal = '';
          payload.daysWithoutAds = '';
          return payload;
        }

        payload.behaviorFilter = behaviorFilter;

        if (behaviorFilter === 'expired_no_renewal') {
          payload.monthsWithoutRenewal =
            selectedItems.value.monthsWithoutRenewal;
        }

        if (behaviorFilter === 'active_no_ads_usage') {
          payload.daysWithoutAds = selectedItems.value.daysWithoutAds;
        }

        return payload;
      };

      const onSubmit = async () => {
        const payload = buildFilterPayload();
        await store.dispatch(Actions.UPDATE_OFFICE_FILTER, payload);
        emit('type-selected', payload);
      };

      const onReset = async () => {
        selectedItems.value = {
          email: '',
          phone: '',
          memberType: 'all',
          behaviorFilter: 'all',
          monthsWithoutRenewal: '1',
          daysWithoutAds: '14',
        };
        const payload = {
          email: '',
          phone: '',
          memberType: 'all',
          behaviorFilter: '',
          monthsWithoutRenewal: '',
          daysWithoutAds: '',
        };
        await store.dispatch(Actions.UPDATE_OFFICE_FILTER, payload);
        emit('reset', payload);
      };

      const filter = computed(() => store.getters.getOfficesFilter || {});

      onMounted(() => {
        if (filter.value?.phone) selectedItems.value.phone = filter.value.phone;
        if (filter.value?.email && filter.value.email !== 'undefined') {
          selectedItems.value.email = filter.value.email;
        }
        if (filter.value?.memberType) {
          selectedItems.value.memberType = filter.value.memberType;
        }
        if (filter.value?.behaviorFilter) {
          selectedItems.value.behaviorFilter = filter.value.behaviorFilter;
        }
        if (filter.value?.monthsWithoutRenewal) {
          selectedItems.value.monthsWithoutRenewal = String(
            filter.value.monthsWithoutRenewal
          );
        }
        if (filter.value?.daysWithoutAds) {
          selectedItems.value.daysWithoutAds = String(
            filter.value.daysWithoutAds
          );
        }
      });

      return {
        selectedItems,
        onSubmit,
        onReset,
        translate,
        onBehaviorFilterChange,
      };
    },
  });
